$(document).ready(function () {});

document.addEventListener("DOMContentLoaded", () => {
  const bg = document.querySelector(".scroll-background");
  const btn = document.getElementById("scrollToTop");
  const showAfter = 300;

  if (!bg || !btn) return;

  window.addEventListener("scroll", () => {
    if (window.scrollY > showAfter) {
      bg.classList.add("is-visible");
    } else {
      bg.classList.remove("is-visible");
    }
  });

  btn.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});
